var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal",domProps:{"innerHTML":_vm._s(_vm.block.attrs.code)}},[_vm._v(_vm._s(_vm.block))])
}
var staticRenderFns = []

export { render, staticRenderFns }